import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/small.png'
import _imports_1 from '@/assets/big.png'


const _withScopeId = n => (_pushScopeId("data-v-1dd9748e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "product",
  id: "product"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "product-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product-title-left-img",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product-title-right-img",
  src: _imports_1
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_7 = { class: "product-desc" }
const _hoisted_8 = { class: "product-main-content" }
const _hoisted_9 = { class: "product-main-content-name" }
const _hoisted_10 = { class: "product-main-content-description" }
const _hoisted_11 = { class: "product-main-content-box" }
const _hoisted_12 = ["onMouseenter"]
const _hoisted_13 = { class: "product-main-content-title-icon" }
const _hoisted_14 = { class: "product-main-content-content-name" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "product-main-img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.titleType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.productTitleDesc.title) + " ", 1),
            _hoisted_5
          ]),
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.productTitleDesc.desc), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["product-main", { productType: _ctx.titleType }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.productModule.name), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.productModule.description), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productModule.articles, (articles, articlesIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: articlesIndex,
              class: _normalizeClass(["product-main-content-title", { backGroundColor: articlesIndex === _ctx.productIndex }]),
              onMouseenter: ($event: any) => (_ctx.product(articles.img, articlesIndex))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_svg_icon, {
                  name: "left",
                  color: 'blue',
                  isShow: articlesIndex === _ctx.productIndex
                }, null, 8, ["isShow"])
              ]),
              _createElementVNode("a", null, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(articles.name), 1),
                _createElementVNode("p", {
                  class: "product-main-content-content",
                  innerHTML: articles.content
                }, null, 8, _hoisted_15)
              ])
            ], 42, _hoisted_12))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_Transition, {
          name: _ctx.style,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.productUrl == '' ? _ctx.productModuleImg : _ctx.productUrl
                }, null, 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.productUrl
                }, null, 8, _hoisted_18))
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ], 2)
  ]))
}